import { createRouter, createWebHistory } from 'vue-router'
import { auth } from '../firebase/config'

// Auth Guards
const requireAuth = (to, from, next) => {
  let user = auth.currentUser
  if (!user) {
    next({ name: 'Login' })
  }
  next()
}

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackChunkName: "[landing_v1]" */ '../views/HomeView.vue')
  },
  {
    path: '/thankyou',
    name: 'ThankYou',
    component: () => import(/* webpackChunkName: "[thankyou_v1]" */ '../views/ThankYouView.vue')
  },
  {
    path: '/nominateyourteacher',
    name: 'NominateTeacher',
    component: () => import(/* webpackChunkName: "[nominateyourteacher_v1]" */ '../views/NominateYourTeacherView.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "[login_v1]" */ '../views/login/LoginView.vue')
  },
  {
    path: '/forgotpassword',
    name: 'ForgptPassword',
    component: () => import(/* webpackChunkName: "[forgotpassword_v1]" */ '../views/login/ForgotPasswordView.vue')
  },
  {
    path: '/requestaccess',
    name: 'RequestAccess',
    component: () => import(/* webpackChunkName: "[requestaccess_v1]" */ '../views/login/RequestAccessView.vue')
  },
  {
    path: '/blog',
    name: 'Blog',
    beforeEnter: requireAuth,
    component: () => import(/* webpackChunkName: "[blog_v1]" */ '../views/BlogView.vue')
  },
  {
    path: '/approvals',
    name: 'Approvals',
    beforeEnter: requireAuth,
    component: () => import(/* webpackChunkName: "[approvals_v1]" */ '../views/admin/ApprovalView.vue')
  },
  {
    path: '/setpassword/:id',
    name: 'SetPassword',
    component: () => import(/* webpackChunkName: "[setPassword_v1]" */ '../views/SetPasswordView.vue'),
    props: true,
  },
  {
    path: '/printthankyou/:id',
    name: 'PrintThankYou',
    component: () => import(/* webpackChunkName: "[print_v1]" */ '../views/PrintThankYouView.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
